import styled from "styled-components";
import {Tabs, Card, Button, Drawer, DatePicker, Table, Descriptions, Row} from "antd";

export const Img = styled.img`
    height: 150px;
    display: flex;
    margin: auto;
    border-radius: 50%;
    border: 10px solid #fafafa;
    box-sizing: content-box;
`;

export const TableContainer = styled(Table)`
    .ant-table-tbody > tr > td {
        min-width: 100px;
    }
`;

export const TimelineCard = styled(Card)`
    width: 60%;
    float: ${props => props.right === "true" && "right"};
    .ant-card-body {
        padding: 12px;
    }
`;

export const LeftButton = styled(Button)`
    padding: 0px 8px;
    font-size: 12px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const DrawerContainer = styled(Drawer)`
    position: absolute;
`;

export const PastTabContainer = styled.div`
    min-height: max(calc(100vh - 260px), 500px);
`;

export const DateRangePicker = styled(DatePicker)`
    width: 100%;
`;

export const TableTitle = styled.h3`
    margin-top: 20px;
    margin-bottom: 15px;
`;

export const RightButton = styled(Button)`
    float: right;
`;

export const TimeLineDuration = styled.p`
    font-size: 13px;
    font-weight: bold;
`;

export const DescriptionContainer = styled(Descriptions)`
    margin-bottom: 20px;
    border-left: 2px solid ${props => props.color};
`;
export const ColoredLine = styled.div`
    position: absolute;
    top: 11px;
    left: -17px;
    background-color: ${props => props.color};
    width: 19px;
    height: 2px;
`;

export const TabsContainer = styled(Tabs)`
    @media (max-width: 1200px) {
        .ant-tabs-nav {
            flex-wrap: wrap;
        }
        .ant-tabs-nav > .ant-tabs-extra-content {
            width: 100%;
        }
        .ant-tabs-nav > .ant-tabs-extra-content > div > div {
            display: flex;
            flex-direction: column;
        }
    }
    @media (max-width: 768px) {
        .ant-tabs-nav > .ant-tabs-extra-content > div > div {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    }
`;

export const TopContainer = styled(Row)`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const EditButton = styled(Button)`
    background-color: black;
    border: 0;
    &:hover {
        background-color: rgba(0, 0, 0, 0.7);
    }
`;

export const SelectContainer = styled(Row)`
    margin-bottom: 10px;
`;

export const CourierPersonalInfoRow = styled(Row)`
    font-size: 14px;
    font-weight: normal;
    justify-content: center;
    margin-bottom: 8px;
`;
